import clsx from 'clsx'
import Image from 'next/image'

import AiButton from 'components/ai-bolit/landing/ai-button/ai-button'
import usePCWindow from 'hooks/usePCWindow'

import { ScreenSize } from 'constants/media-constanst'
import { STATIC_URL } from 'constants/data'
import { A_LOG_REG_HASH, originAIBOLIT } from 'utils/analytics/other/registration/registration'

import styles from './ai-landing-banner.module.scss'
import commnomStyle from '../landing-common.module.scss'

const imgDesc = {
  src: `${STATIC_URL}/ai-bolit/banner-bg.png`,
  alt: 'Задний фон',
  width: 610,
  height: 392,
  unoptimized: true,
}

const imgMob = {
  src: `${STATIC_URL}/ai-bolit/banner-bg-mob.png`,
  alt: 'Задний фон',
  width: 519,
  height: 315,
  unoptimized: true,
}

const AiLangingBanner = () => {
  const isBigPc = usePCWindow(ScreenSize.big)
  return (
    <div className={clsx(commnomStyle.section, styles.wrapper)}>
      <div className={styles.imgWrapper}>
        {isBigPc ? <Image className={styles.deskImg} {...imgDesc} /> : <Image {...imgMob} />}
      </div>
      <div className={styles.content}>
        <div className={styles.title}>
          Начните использовать <span className={styles.medicus}>AI Bolit</span> уже сегодня
        </div>
        <div className={styles.txt}>
          Откройте для себя новый уровень эффективности в вашей медицинской практике!
        </div>
      </div>
      <div
        className={styles.btn}
        onClick={() => sessionStorage.setItem(A_LOG_REG_HASH, originAIBOLIT.AIBOLITUSE)}
      >
        <AiButton>Начать использовать</AiButton>
      </div>
    </div>
  )
}

export default AiLangingBanner
